module.exports = __webpack_public_path__ + "img/information_ethical_mob.d69c15a.jpg";